import {
    FETCH_INVESTORTRACKING_BEGIN,
    FETCH_INVESTORTRACKING_SUCCESS,
    FETCH_INVESTORTRACKING_FAILURE,
    FETCH_INVESTORTRACKINGTRANSACTIONTYPE_BEGIN,
    FETCH_INVESTORTRACKINGTRANSACTIONTYPE_SUCCESS,
    FETCH_INVESTORTRACKINGTRANSACTIONTYPE_FAILURE,
    FETCH_INVESTORTRACKINGPORTFOLIO_BEGIN,
    FETCH_INVESTORTRACKINGPORTFOLIO_SUCCESS,
    FETCH_INVESTORTRACKINGPORTFOLIO_FAILURE,
    FETCH_INVESTORTRACKINGASSET_BEGIN,
    FETCH_INVESTORTRACKINGASSET_SUCCESS,
    FETCH_INVESTORTRACKINGASSET_FAILURE,
    FETCH_INVESTORTRACKINGSTATUS_BEGIN,
    FETCH_INVESTORTRACKINGSTATUS_SUCCESS,
    FETCH_INVESTORTRACKINGSTATUS_FAILURE,
  } from '../constants/investorTracking';


const initialState={
    investortrackingList:[{}],
    transactionTypes:[],
    investorStatus:[],
    investorAssets:[],
    investorPortfolio:[],
    isLoading:false,
    error:""
}


export const getInvestorTrackingListReducer = (state=initialState,action) => {
    const {type,payload}=action;
 switch(type)
 {
    case FETCH_INVESTORTRACKING_BEGIN:
        return {
          ...state,
          isLoading: true,
          error: null,
        };
      
    case FETCH_INVESTORTRACKING_SUCCESS:
        return {
            ...state,
            investortrackingList:payload.investortrackingList,
            isLoading:false,
        };
        case FETCH_INVESTORTRACKING_FAILURE:
            return {
                ...state,
                isLoading:false,
                investortrackingList:null
            };
        // Transaction Types
        case FETCH_INVESTORTRACKINGTRANSACTIONTYPE_BEGIN: 
            return {
              ...state,
              isLoading: true,
              error: null,
            };
        
            case FETCH_INVESTORTRACKINGTRANSACTIONTYPE_FAILURE:
                return {
                    ...state,
                    isLoading:true,
                    transactionTypes:null
                };
                case FETCH_INVESTORTRACKINGTRANSACTIONTYPE_SUCCESS:
                    return {
                        ...state,
                        transactionTypes: payload.transactionTypes,
                        isLoading:false,
                      };
                       // Asset
        case FETCH_INVESTORTRACKINGASSET_BEGIN: 
        return {
          ...state,
          isLoading: true,
          error: null,
        };
    
        case FETCH_INVESTORTRACKINGASSET_FAILURE:
            return {
                ...state,
                isLoading:true,
                investorAssets:null
            };
            case FETCH_INVESTORTRACKINGASSET_SUCCESS:
                return {
                    ...state,
                    investorAssets: payload.investorAssets,
                    isLoading:false,
                  };
                   // PORTFOLIO
        case FETCH_INVESTORTRACKINGPORTFOLIO_BEGIN: 
        return {
          ...state,
          isLoading: true,
          error: null,
        };
    
        case FETCH_INVESTORTRACKINGPORTFOLIO_FAILURE:
            return {
                ...state,
                isLoading:true,
                investorPortfolio:null
            };
            case FETCH_INVESTORTRACKINGPORTFOLIO_SUCCESS:
                return {
                    ...state,
                    investorPortfolio: payload.investorPortfolio,
                    isLoading:false,
                  };
                   // Status
        case FETCH_INVESTORTRACKINGSTATUS_BEGIN: 
        return {
          ...state,
          isLoading: true,
          error: null,
        };
    
        case FETCH_INVESTORTRACKINGSTATUS_FAILURE:
            return {
                ...state,
                isLoading:true,
                transactionTypes:null
            };
            case FETCH_INVESTORTRACKINGSTATUS_SUCCESS:
                return {
                    ...state,
                    investorStatus: payload.investorStatus,
                    isLoading:false,
                  };
    default:
        return state;
 }
}

export default getInvestorTrackingListReducer



